import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class StatuAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: ''
            },
            loading: false,
            isLoad: true
        }
    }
    handleChance = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }))
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const statuFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            statuFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/operation/status/add', 'post', statuFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }

    }
    render() {
        const { loading } = this.state;
        const { userPermissions } = this.props;
        const userHasNewNotifyPermission = userPermissions.includes('new setting service status');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}>
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Servis durumu ekle"
                            Breadcrumb={[
                                { name: "Servis durumları", navigate: "status" },
                                { name: "Yeni servis durumu", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <small>ServiceZone'da servis durumları, araç bakım ve onarım süreçlerinin hangi aşamada olduğunu takip etmenize yardımcı olur. Her servis durumu, işlemin ne aşamada olduğunu belirterek hem işletmenize hem de müşterilerinize süreç hakkında net bilgi sunar. Bu sayede, servisin başlangıcından teslimatına kadar olan tüm adımlar sistematik bir şekilde izlenir, müşteriler düzenli olarak bilgilendirilir ve hizmetlerin takibi daha verimli hale gelir.</small>
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="name"
                                                            className="form-control"
                                                            placeholder="Servis durumu adı"
                                                            type="text"
                                                            onChange={this.handleChance}
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">
                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewNotifyPermission}
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StatuAdd)));
